import * as React from "react";
import Container from "./styled";
import { BsCheckLg } from "react-icons/bs";
import { Link } from "react-scroll";
import { Fade } from "react-awesome-reveal";

export default function Cubrimos({ landingVehiculo }) {
  return (
    <Container>
      {/* Coberturas Container */}
      <Fade
        delay={100}
        duration={600}
        triggerOnce={false}
        className="fade-container"
      >
        {/* Coberturas Container */}
        <div className="coberturas-container">
          {/* Titulo */}
          <h2>
            ¡Hay <span>muchas coberturas</span> para vos y tu moto!
          </h2>
          {/* Columna 1 */}
          <div className="columna">
            {/* Tag */}
            <div className="tag">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Robo total y parcial
              </p>
            </div>
            <div className="line-break"></div>
            {/* Tag */}
            <div className="tag">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Destrucción total
              </p>
            </div>
          </div>
          {/* Columna 2 */}
          <div className="columna">
            {/* Tag */}
            <div className="tag">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Daños parciales
              </p>
            </div>
            {/* Tag */}
            <div className="tag">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Resp. civil
              </p>
            </div>
          </div>
          {/* Columna 3 */}
          <div className="columna">
            {/* Tag */}
            <div className="tag">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Asistencia mecánica
              </p>
            </div>
            {/* Tag */}
            <div className="tag">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Muchos descuentos
              </p>
            </div>
          </div>
          {/* Botón Cotizar */}
          <Link
            to="cotizador"
            smooth={true}
            spy={true}
            duration={300}
            offset={-200}
          >
            ¡Cotizá tu seguro!
          </Link>
        </div>
      </Fade>
    </Container>
  );
}
